const constructData = (envelope, data, payloadMetaAttributes) => {
  return {
    ...envelope,
    customAttributes: {
      ...data,
      ...payloadMetaAttributes,
    },
  };
};

export default constructData;
